// EncryptText.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { encryptText, decryptText } from '../../../helpers/helpers';
import { useContext } from 'react';
import ConfigContext from '../../../contexts/configContext';

const EncryptText = () => {
	const { text } = useParams(); // Get the 'text' parameter from the URL

	const [encryptedText, setEncryptedText] = useState('');
	const secretKey = 'mlpoknijbbhuygvcftrdxeszawq'; // Replace with a secure key
	useEffect(() => {
		if (text) {
			const encrypted = encryptText(text, process.env.REACT_APP_SECRET_KEY || secretKey);
			setEncryptedText(encrypted);
		}
	}, [text, secretKey]);

	return (
		<div className='m-2'>
			<h1>Text Encryption and Decryption</h1>
			{text ? (
				<>
					<p>Encrypted Text= {encryptedText}</p>
				</>
			) : (
				<p>No text provided in the URL. Use /encrypt/YourText</p>
			)}
		</div>
	);
};

export default EncryptText;
